import React from "react";
import { GuideDetail } from "../components/GuideDetail";

export default function GuideDetailPage() {
  return <div className="pt-10"><GuideDetail /></div>;
}
